import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    font-family: ${({ theme }) => theme.fontFamily.primary};
    font-style: normal;
  }

  button {
    font-family: ${({ theme }) => theme.fontFamily.primary};
    font-style: normal;
    text-transform: none;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: ${({ theme }) => theme.fontFamily.primary};
    font-style: normal;
    line-height: 1.5em;
    font-size: 12px;
  }

  .MuiAutocomplete-popper .MuiAutocomplete-paper {
    border-radius: 10px;
    margin-top: 10px;
    font-size: 0.8rem;
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.04), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 6px 30px 5px rgba(0, 0, 0, 0.04);

  }

  .MuiDrawer-root .MuiDrawer-paper {
    border-radius: 10px;
    margin: 10px;

  }

  .react-multi-carousel-item{
    max-width: 220px;
    min-width: 220px;
}

  .MuiOutlinedInput-root MuiInputBase-root {
    font-family: urw-form, sans-serif !important;
    padding-left: 1px;
  }

  .MuiCheckbox-root {
    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.checkbox.uncheckedBorder};
    }

    &.Mui-checked {
      .MuiSvgIcon-root {
        color: ${({ theme }) => theme.checkbox.primaryChecked};
      }

      &.Mui-disabled {
        .MuiSvgIcon-root {
          color: ${({ theme }) => theme.checkbox.disabled};
        }
      }

    }

  }

  .MuiButton-root {
    text-transform: none !important;
  }

  .MuiLoadingButton-root MuiButton-root MuiButton-outlined {
    font-family: ${({ theme }) => theme.fontFamily.primary};
  }

  /* disable increase arrow from number input textfield */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  /* */

  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollBar.track};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollBar.thumb};
    border-radius: 10px;
    border: 4px solid transparent;
    background-clip: content-box;
  }

  // styles related to Time Picker
  .rc-time-picker-panel-select li{
    width: unset !important;
  }

  .rc-time-picker-panel-select-option-selected {
    background-color : ${({ theme }) => theme.app.secondary} !important;
    color: ${({ theme }) => theme.text.smText} !important;
  }

  .rc-time-picker-panel {
    z-index: 2222 !important; // added to render Time Picker when MUI Drawer is used
  }

  .rc-time-picker-panel-input {
    font-size: ${({ theme }) => theme.fontSize.medium} !important;;
  }

  // styles related to autofill
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active{
    -webkit-background-clip: text;
    -webkit-text-fill-color: inherit;
  }
`;

export default GlobalStyle;
